// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-75c62d28] {\n  position: absolute;\n  left: -2px;\n  font-size: 0.8rem;\n  top: 0;\n  transform: translateY(-65%);\n  color: #fff;\n  font-weight: 500;\n  padding: 0.18rem 1rem;\n  border-radius: 3px 3px 3px 0;\n  transition: opacity 0.3s;\n}\n.badge.primary[data-v-75c62d28] {\n  background-color: #7d8bf7;\n}\n.badge.orange[data-v-75c62d28] {\n  background-color: #f0907e;\n}\n.badge.transparent[data-v-75c62d28] {\n  opacity: 0.7;\n}", ""]);
// Exports
module.exports = exports;
